import React from "react";
import { aboutImage, stats } from "../../mock";
import SectionLabel from "./SectionLabel";
import Reveal from "./Reveal";

const About = () => {
  return (
    <section id="chi-siamo" className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
      <SectionLabel>Chi siamo</SectionLabel>

      <div className="grid md:grid-cols-2 gap-12 md:gap-20 mt-10 items-start">
        <Reveal>
          <div className="img-zoom rounded-sm">
            <img
              src={aboutImage}
              alt="ONEVO Premium Training Studio Reception"
              className="w-full h-[440px] md:h-[560px] object-cover rounded-sm"
            />
          </div>
        </Reveal>

        <Reveal delay={120}>
          <h2 className="font-display text-4xl md:text-6xl text-white">
            Il tuo obiettivo.{" "}
            <span className="text-white/45" style={{ fontStyle: "italic", fontWeight: 800 }}>
              La nostra direzione.
            </span>
          </h2>
          <p className="text-white/70 text-base md:text-lg leading-relaxed mt-8">
            Dimagrire, aumentare la massa muscolare, migliorare la postura o ritrovare energia: ogni
            obiettivo merita un piano preciso. Ti seguiamo passo dopo passo con allenamento
            individuale, progressioni mirate e il supporto di professionisti qualificati.
          </p>
          <p className="text-white/70 text-base md:text-lg leading-relaxed mt-4">
            Per trasformare l'impegno in risultati reali.
          </p>

          <div className="grid grid-cols-2 border-t border-l border-white/10 mt-12">
            {stats.map((s) => (
              <div key={s.label} className="border-b border-r border-white/10 p-6 md:p-8">
                <div className="font-display text-4xl md:text-5xl text-white">
                  {s.value}
                  <span className="text-white/45">{s.suffix}</span>
                </div>
                <div className="font-mono-label text-[10px] text-white/45 mt-3">{s.label}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
